import { makeGetRequest } from 'lib/axios';

export type SclaSignUpInvite = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  schoolName: string;
  gradeLevel: string;
};

/** Prefill for an SCLA interest-email invite token, or null when unknown or expired. */
const getSclaSignUpInvite = async (
  token: string,
): Promise<SclaSignUpInvite | null> => {
  const url = `/auth/sign-up-invite/${encodeURIComponent(token)}`;
  const response = await makeGetRequest(url);
  return response.data.payload ?? null;
};

export default getSclaSignUpInvite;
